import { lazy } from "react";

import { Box, Heading, Stack, Text } from "@seneca/senekit";

import ManualTransferButton from "./ManualTransferButton";

const TransferErrorAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: "transfer-subscription-error-animation" */ "../animations/TransferErrorAnimation"
    )
);

export default function TransferErrorPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
      paddingTop={["none", "xlarge"]}
      paddingX={["none", "large"]}
      minHeight={["100%", "400px"]}
      alignItems="center"
    >
      <Stack align="center">
        <TransferErrorAnimation />
        <Stack align="center" space="xlarge">
          <Heading align="center" level="4">
            Hmm, something went wrong 🤔
          </Heading>
          <Text align="center">
            We weren't able to transfer your subscription. Please click below &
            fill in the form so that we can get this sorted out ASAP for you!
          </Text>
        </Stack>
      </Stack>
      <Box padding="xlarge" />
      <ManualTransferButton />
    </Box>
  );
}
